import { useState, useEffect } from 'react';
import Plus from '../../../../assets/icon/add_circle.svg';
import Cross from '../../../../assets/icon/cross-circle.svg';
import infoIcon from '../../../../assets/icon/info.svg';
import { getLoadStopCommodities } from '../../../Utils/LoadStopCommoditiesUtil';
import { TFloatingBtnContainerProps } from './FloatingBtnContainer.type';
import { specialServicesDesc } from '../LoadCard/ExpandedViewContainer/ExpandedViewContainer';
import CustomModal from '../CustomModal/CustomModal';
import LoadCommoditiesContainer from '../LoadCard/ExpandedViewContainer/LoadCommoditiesContainer/LoadCommoditiesContainer';
import LoadRateContainer from '../LoadCard/ExpandedViewContainer/LoadRateContainer/LoadRateContainer';
import LoadServicesContainer from '../LoadCard/ExpandedViewContainer/LoadServicesContainer/LoadServicesContainer';
import LoadDocumentsContainer from '../LoadCard/ExpandedViewContainer/LoadDocumentsContainer/LoadDocumentsContainer';
import './FloatingBtnContainer.scss';

const sideBarItems = [
  {
    icon: '/oo/assets/icon/services.svg',
    title: 'Services',
  },
  {
    icon: '/oo/assets/icon/commodities.svg',
    title: 'Commodities',
  },

  {
    icon: '/oo/assets/icon/add_invoice.svg',
    title: 'Rate',
  },

  {
    icon: '/oo/assets/icon/document-icon.svg',
    title: 'Documents',
  },
];

const FloatingBtnContainer = (props: TFloatingBtnContainerProps) => {
  const { data, isMyLoads = false } = props;
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [servicesModalProps, setServicesModalProps] = useState<any>({
    isModalOpen: false,
  });
  const [commoditiesModalProps, setCommoditiesModalProps] = useState<any>({
    isModalOpen: false,
  });
  const [rateModalProps, setRateModalProps] = useState<any>({
    isModalOpen: false,
  });
  const [documentsModalProps, setDocumentsModalProps] = useState<any>({
    isModalOpen: false,
  });
  const [selectedItemsCount, setSelectedItemsCount] = useState(0);
  const toggleSideBar = () => {
    setIsSidebarOpen((prev) => !prev);
  };
  const calculateTrueItemsCount = (items: any[], data: any) => {
    return items.filter((item) => shouldRenderSidebarItem(item, data)).length;
  };
  const updateCSSVariable = (count: number) => {
    document.documentElement.style.setProperty('--true-items-count', count.toString());
  };
  useEffect(() => {
    const trueItemsCount = calculateTrueItemsCount(sideBarItems, data);
    updateCSSVariable(trueItemsCount);
  }, [data]);
  const onSelectedTab = (selectedTab: string) => {
    if (sideBarItems[0].title === selectedTab) {
      if (data) {
        setServicesModalProps({
          isModalOpen: true,
          titleIcon: infoIcon,
          title: 'Services Details',
          closeModalAction: () => setServicesModalProps({ isModalOpen: false }),
          contentAlignment: 'center',
          additionalCssClass: ' additional-css rate-modal',
          backdropDismiss: true,
          children: (
            <LoadServicesContainer
              services={specialServicesDesc(data)}
              tableTitle={'Services Details'}
            />
          ),
        });
      }
    } else if (sideBarItems[1].title === selectedTab) {
      setCommoditiesModalProps({
        isModalOpen: true,
        titleIcon: infoIcon,
        title: 'Commodity Detail',
        closeModalAction: () => setCommoditiesModalProps({ isModalOpen: false }),
        contentAlignment: 'left',
        backdropDismiss: true,
        additionalCssClass: ' additional-css commodities-modal',
        contentScroll: 'deny',
        children: (
          <LoadCommoditiesContainer
            commodities={data?.loadCommodityList || getLoadStopCommodities(data?.shipmentStops)}
            modalView={true}
          />
        ),
      });
    } else if (sideBarItems[2].title === selectedTab) {
      if (data?.rate || data?.shipmentCostItems) {
        setRateModalProps({
          isModalOpen: true,
          titleIcon: infoIcon,
          title: 'Rate Details',
          closeModalAction: () => setRateModalProps({ isModalOpen: false }),
          contentAlignment: 'center',
          additionalCssClass: ' additional-css rate-modal',
          backdropDismiss: true,
          children: (
            <LoadRateContainer
              tableTitle={'Rate Details'}
              rate={data?.rate || data?.shipmentCostItems}
              totalCostAmount={data?.totalCostAmount}
              isMyLoads={isMyLoads}
            />
          ),
        });
      }
    } else if (sideBarItems[3].title === selectedTab) {
      setDocumentsModalProps({
        isModalOpen: true,
        titleIcon: infoIcon,
        title: 'Available Documents',
        closeModalAction: () => setDocumentsModalProps({ isModalOpen: false }),
        contentAlignment: 'center',
        additionalCssClass: ' additional-css rate-modal',
        backdropDismiss: true,
        children: (
          <LoadDocumentsContainer
            id={data?.shipmentId}
            sourceTms={data?.sourceTMS}
            modalView={true}
            isMyLoads={isMyLoads}
          />
        ),
      });
    }
  };
  const shouldRenderSidebarItem = (item: any, data: any) => {
    const myLoadsCommodity = (isMyLoads && getLoadStopCommodities(data?.shipmentStops)) || [];
    if (item.title === 'Rate' && !data?.rate && !data?.totalCostAmount) return false;
    if (item.title === 'Documents' && !isMyLoads) return false;
    if (item.title === 'Services' && (!data?.specialServices || data?.specialServices.length === 0))
      return false;
    if (
      item.title === 'Commodities' &&
      (data?.loadCommodityList?.length === 0 || (isMyLoads && myLoadsCommodity?.length === 0))
    )
      return false;
    return true;
  };

  return (
    <div>
      <CustomModal {...servicesModalProps} />
      <CustomModal {...commoditiesModalProps} />
      <CustomModal {...rateModalProps} />
      <CustomModal {...documentsModalProps} />
      <div className={`Sidebar_Wrapper ${isSidebarOpen ? 'open' : ''}`}>
        <div className={`Sidebar ${isSidebarOpen ? 'open' : ''}`}>
          <div className="Sidebar_Content">
            <div className="Sidebar_Item">
              {isSidebarOpen &&
                sideBarItems?.map((item: any) => {
                  if (!shouldRenderSidebarItem(item, data)) return <></>;
                  return (
                    <div
                      key={item.title}
                      onClick={() => {
                        onSelectedTab(item.title);
                      }}
                      className="Sidebar_Options"
                    >
                      <img src={item.icon} alt={item.title} />
                      <p>{item.title}</p>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      <div className="FloatingBtnContainer" onClick={toggleSideBar}>
        <img src={isSidebarOpen ? Cross : Plus} alt="sidebar" />
      </div>
    </div>
  );
};

export default FloatingBtnContainer;
